import _ from 'lodash';

import Browser from './pdf-print-js/browser';

export const isSetSSOPopupWindow = () => _.get(window, 'SSOPopup', null);

export const setSSOPopup = (popup) => (window.SSOPopup = popup);

export const isSSOPopupWindow = () => {
  if (Browser.isSafari()) {
    const isPopup = localStorage.getItem('isSSOPopupOpen') === 'true';

    if (isPopup) {
      localStorage.removeItem('isSSOPopupOpen');
    }

    return isPopup;
  } else {
    return !_.isNil(window.opener) && !window.toolbar.visible;
  }
};

export const closeSSOPopup = () => isSetSSOPopupWindow() && window.SSOPopup.close();

export const focusSSOPopup = () => isSetSSOPopupWindow() && window.SSOPopup.focus();
